import { type Translationtype } from "utils";
import { Tooltip } from "../components/tooltip";

interface IFormCheckboxProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  name: string;
  title: string | React.ReactElement;
  tooltip?: string;
  isDefaultChecked?: boolean;
  t: Translationtype;
  mainTitle?: string;
  loading?: boolean;
  isRequired?: boolean;
}

export function FormCheckbox({
  register,
  errors,
  className,
  name,
  title,
  tooltip,
  disabled,
  isDefaultChecked,
  t,
  mainTitle,
  loading = false,
  isRequired,
}: IFormCheckboxProps) {
  return (
    <div className={`${className || ""} w-full flex flex-col items-start`}>
      <div className="flex flex-row items-center w-full">
        <input
          id={`chkbx_${name}`}
          type="checkbox"
          className="checkbox mr-3"
          disabled={disabled || false}
          defaultChecked={isDefaultChecked}
          {...register(name)}
        />
        <label
          htmlFor={`chkbx_${name}`}
          className="text-textColor cursor-pointer"
        >
          {mainTitle ? <span className="font-bold">{mainTitle}</span> : null}
          {loading ? (
            <span className="loading loading-spinner w-4 h-4" />
          ) : (
            title
          )}
          {isRequired ? <span className="text-red-500"> *</span> : null}
          {tooltip ? <Tooltip text={tooltip} /> : null}
        </label>
      </div>
      {errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
